import { Button, Flex } from '@chakra-ui/react';
import { EmptyState } from 'components/ds';
import { Languages, Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface StartTask {
  onAddNew: () => void;
}

/* DS welcome / empty state — centered icon + title + text + ds-primary CTA (design-guidelines.md §4 EmptyState) */
const StartTask = ({ onAddNew }: StartTask) => {
  const { t } = useTranslation();
  return (
    <Flex align='center' justify='center' w='100%' h='100%'>
      <EmptyState
        variant='hero'
        icon={<Languages size={26} />}
        title={t('translator.welcome')}
        description={t('translator.description')}
        action={
          <Button
            leftIcon={<Plus size={18} />}
            onClick={onAddNew}
            size='ds-lg'
            variant='ds-primary'
          >
            {t('translator.start')}
          </Button>
        }
      />
    </Flex>
  );
};

export default StartTask;
